import { useQuery } from '@tanstack/react-query';
import type { UndefinedInitialDataOptions } from '@tanstack/react-query/src/queryOptions';

import { getVideoQRById } from '~/api/microsites/video';
import { qrCodeKeys } from '~/constants/queryKeys';

export default function useVideoQrData({
  videoId,
}: { videoId: string | number } & Partial<UndefinedInitialDataOptions>) {
  return useQuery({
    queryFn: () => getVideoQRById(videoId),
    queryKey: qrCodeKeys.videoQRDataById(videoId),
    enabled: !!videoId,
    select: (response) => response.data,
  });
}
